import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { MoveLeft } from "lucide-react";
import { useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import { toast } from "react-hot-toast";

// import { forgotPassword } from "../../redux/slices/authSlice";

import "../Loginsignup/login-signup.css";

export default function ForgotPassword() {
  // const dispatch = useDispatch();
  const navigate = useNavigate(); // Define navigate
  const { loading, error } = useSelector((state) => state.auth); // Define loading and error
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const [formData, setFormData] = useState({
    email: "",
  });

  useEffect(() => {
    // body bg color
    document.body.style.backgroundColor = "#f0f0f0";
    return () => {
      document.body.style.backgroundColor = "#fff";
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.email === "") {
      toast.error("Email is required");
      return;
    }

    // dispatch(forgotPassword(formData.email));
    toast.success("Password reset link sent to your email");
    navigate("/otp-verification");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Left Panel - Candy World */}
        {isDesktop && (
          <div className="login-panel candy-panel">
            {isDesktop && (
              <div className="back-button">
                <button>
                  <MoveLeft size={24} color="#fff" />
                </button>
              </div>
            )}
            <div className="candy-content">
              <h2 className="candy-title">Your Candy World</h2>
              <h3 className="candy-subtitle">Awaits</h3>
              <div className="curved-line"></div>
              <p className="candy-description">
                Manage your orders, track shipments, and discover exclusive deals. Enjoy new arrivals, special discounts,
                and a world of delightful treats just for you!
              </p>
            </div>
            <div className="candy-image">
              <img
                src="/1.png"
                alt="Candy character"
              />
            </div>
          </div>
        )}

        {/* Right Panel - Forgot Password Form */}
        <div className="login-panel form-panel">
          {/* {!isDesktop && (
            <div className="right-top-button">
              <button>
                <MoveLeft size={24} color="#000" />
              </button>
            </div>
          )} */}
          <div className="brand-logo">
            <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1742812127/derby-logo_1_goi8kp.png" alt="Derby logo" className="logo-image" />
          </div>
          <div className="form-header">
            <h2>Forgot Password</h2>
            <p className="form-subtitle">
              Enter your email address to receive a password reset link
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Processing..." : "Send Password Reset Link"}
            </button>
          </form>

          <div className="auth-switch">
            <p>
              Remember your password? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}